<template>
  <a
    v-if="href"
    class="whatsapp-launcher"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    :aria-label="$t('partner.whatsapp')"
  >
    <v-icon size="34" color="white">mdi-whatsapp</v-icon>
  </a>
</template>

<script setup>
import { useBrandingStore } from '@/store/branding'
import { loadBoti } from '@/utils/supportWidget'

const branding = useBrandingStore()
const href = computed(() => (branding.loaded ? branding.whatsappUrl : ''))

onMounted(async () => {
  await branding.load()
  if (!branding.whatsappUrl) loadBoti()
})
</script>

<style scoped>
.whatsapp-launcher {
  position: fixed;
  z-index: 1100;
  right: 20px;
  bottom: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  text-decoration: none;
}

.whatsapp-launcher:hover {
  background: #1ebe5d;
}
</style>
